import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202508: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202508",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-08-01",
  endDate: "2025-08-31",
  impressions: 6404,
  clicks: 101,
  adsSpendDollars: 341,
  budgetDollars: 1500,
  salesDollars: 27677,
  bestEstimateRoas: 81.16,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.23,
  newCustomersAcquired: 4,
  dataAvailableAtDate: "2025-09-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
